import Vue, { VNode } from 'vue';
import i18next from "i18next";
import VueI18Next from "@ringana/vue-i18next";
import I18NextLocizeBackend from "i18next-locize-backend";
import App from './App.vue';
import config from "../configs/config";
import { ELanguage } from "./common/enums/index.enum";
import CookieHelper from "./helpers/cookie-helper";

Vue.config.productionTip = false;
Vue.use(VueI18Next);

let initializedVueI18Next: VueI18Next;

void i18next
  .use(I18NextLocizeBackend)
  .init({
    backend: {
      projectId: config.locize.PROJECTID,
      referenceLang: ELanguage.DE,
      version: `latest`,
    },
    fallbackLng: ELanguage.DE,
    fallbackNS: config.locize.namespace.GENERAL,
    lng: CookieHelper.getLanguageCookie() || new URLSearchParams(window.location.search).get(`lang`) || undefined,
    ns: [config.locize.namespace.GENERAL, config.locize.namespace.LIST],
    supportedLngs: Object.keys(ELanguage).map(key => ({ id: ELanguage[key as keyof typeof ELanguage], name: key })).map(entry => entry.id) as string[],
  }, (err: Error) => {
    if(err) {
      console.error(err);
    }
  });

const setUpI18Next = (): VueI18Next => {
  if(initializedVueI18Next) {
    return initializedVueI18Next;
  }

  initializedVueI18Next = new VueI18Next(i18next);
  return initializedVueI18Next;
};

const i18n = setUpI18Next();
Vue.prototype.i18n = i18n;

new Vue({
  i18n,
  render: (h): VNode => h(App),
}).$mount(`#ccn`);
